import { Icon } from 'components/Icon';
import { theme } from 'ui/theme-color';

export const ProposalSteps = ({ icon1, icon2, icon3 }) => (
  <div
    style={{
      position: 'relative',
      width: '75%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '2rem 0 3rem 0',
    }}
  >
    <hr
      style={{
        border: 'none',
        height: '4px',
        width: '88%',
        background: `linear-gradient(
                        to right,
                        ${icon1?.color ?? theme.palette.colors.lightgrey} 47%,
                        transparent 47%,
                        transparent 53%,
                        ${icon3?.color ?? theme.palette.colors.lightgrey} 53%
                      )`,
        position: 'absolute',
        top: -15,
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: '0.8',
      }}
    />
    <Icon
      name={icon1?.name ?? 'circle_circle'}
      size={42}
      fill={icon1?.fill ?? false}
      color={icon1?.color ?? theme.palette.colors.lightgrey}
      elementAttributes={{
        style: {
          position: 'absolute',
        },
      }}
    />
    <Icon
      name={icon2?.name ?? 'circle_circle'}
      size={42}
      color={icon2?.color ?? theme.palette.colors.lightgrey}
      elementAttributes={{
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) ',
        },
      }}
      fill={icon2?.fill ?? false}
    />
    <Icon
      name={icon3?.name ?? 'circle_circle'}
      size={42}
      color={icon3?.color ?? theme.palette.colors.lightgrey}
      elementAttributes={{
        style: {
          position: 'absolute',
          right: '0',
        },
      }}
      fill={icon3?.fill ?? false}
    />
  </div>
);
